import { useMemo, useEffect } from "react";
import { createCustomEvent } from "./utils.js";
async function handleTrackEvent(pageDetails) {
  try {
    const details = await pageDetails();
    if (details !== void 0) {
      dispatchTrackEvent(() => Promise.resolve(details));
    }
  } catch (error) {
    console.error("[Tealium] Error handling track event:", error);
  }
}
function useTrackEvent(pageDetails) {
  useEffect(() => {
    handleTrackEvent(pageDetails);
  }, [pageDetails]);
}
function useDispatchTrackEvent() {
  const trackEventDispatcher = useMemo(() => {
    return async (pageDetails) => {
      await handleTrackEvent(pageDetails);
    };
  }, []);
  return trackEventDispatcher;
}
async function dispatchTrackEvent(pageDetails) {
  try {
    const details = await pageDetails();
    if (details !== void 0) {
      const event = createCustomEvent(details);
      globalThis.dispatchEvent(event);
    }
  } catch (error) {
    console.error("[Tealium] Error dispatching track event:", error);
  }
}
export {
  dispatchTrackEvent,
  useDispatchTrackEvent,
  useTrackEvent
};
//# sourceMappingURL=use-track-event.js.map
